import Plan from './Plan';

export interface Order {
  plan: Plan;
  cost: number;
  couponId?: string;
}

export function isOrder(obj: any): obj is Order {
  return 'plan' in obj && 'cost' in obj;
}

export interface AppStorePlan {
  id: string;
  name: string;
  period: 'day' | 'month' | 'year';
  plan: Plan;
  price: string;
  isSubscription: boolean;
}



// WEBPACK FOOTER //
// ./src/buy/Order.ts